export const updateUser = async (userData) => {

    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/updateuser`, {
            method: 'put',
            body: userData,
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ.success ? { success: true, message: responseOBJ.message } : { success: false, message: responseOBJ.message };
    } catch (error) {
        return { success: false, message: error.message }
    }
}

export const findUser = async (field, value, fieldsSelected) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/finduser?field=${encodeURIComponent(field)}&value=${encodeURIComponent(value)}&fieldsSelected=${encodeURIComponent(fieldsSelected)}`, {
            method: 'get',
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ.success ? { success: true, userData: responseOBJ.userData, message: responseOBJ.message } : { success: false, message: responseOBJ.message };
    } catch (error) {
        return { success: false, message: error.message }
    }
}

export const findUsers = async (queryJSON, fieldsSelected) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/findusers?query=${encodeURIComponent(queryJSON)}&fieldsSelected=${encodeURIComponent(fieldsSelected)}`, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message }
    }
}

/********************* PARA PODER USAR ESTE ENDPOINT SI O SI HAY QUE ENVIAR EN LA QUERY DE BUSQUEDA EL EMAIL DEL USUARIO A EDITAR *****************************/
export const editUserByQuery = async (queryOBJ, dataOBJ) => {
    try {
        const queryJSON = encodeURIComponent(JSON.stringify(queryOBJ));
        const dataJSON = encodeURIComponent(JSON.stringify(dataOBJ));
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/edituser?query=${queryJSON}&data=${dataJSON}`, {
            method: 'get',
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ.success ? { success: true, message: responseOBJ.message } : { success: false, message: responseOBJ.message };
    } catch (error) {
        return { success: false, message: error.message }
    }
}


/************************************** Empresa *************************************/

export const findCompany = async (field, value, fieldsSelected) => {

    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/findcompany?field=${encodeURIComponent(field)}&value=${encodeURIComponent(value)}&fieldsSelected=${encodeURIComponent(fieldsSelected)}`, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message }
    }
}

export const findCompanys = async (matchJSON, aggregateQueryJSON) => {

    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/findcompanys?match=${encodeURIComponent(matchJSON)}&aggregateQuery=${encodeURIComponent(aggregateQueryJSON)}`, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message }
    }
}

export const findCompanys2 = async (queryJSON, fieldsSlected) => {

    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/findcompanys2?query=${encodeURIComponent(queryJSON)}&fieldsSelected=${encodeURIComponent(fieldsSlected)}`, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message }
    }
}

export const handleFavorite = async (companyId, userEmail, option) => {

    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/handlefavorite?companyId=${encodeURIComponent(companyId)}&userEmail=${encodeURIComponent(userEmail)}&option=${encodeURIComponent(option)}`, {
            method: 'put',
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message }
    }
}

export const addCompany = async (companyData) => {

    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/addcompany`, {
            method: 'post',
            body: companyData,
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ.success ? { success: true, message: responseOBJ.message } : { success: false, message: responseOBJ.message };
    } catch (error) {
        return { success: false, message: error.message }
    }
}

export const updateCompany = async (id, companyData) => {

    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/updatecompany?id=${id}`, {
            method: 'put',
            credentials: 'include',
            body: companyData,
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ.success ? { success: true, message: responseOBJ.message } : { success: false, message: responseOBJ.message };
    } catch (error) {
        return { success: false, message: error.message }
    }
}

export const deleteImageOfFirebase = async (deletePath) => {
    const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/deleteimage?delete=${deletePath}`, {
        method: 'delete',
        credentials: 'include',
    });
    const responseOBJ = await responseJSON.json();
    return responseOBJ;
}

export const deleteCompanyById = async (id) => {
    const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/deletecompany?id=${encodeURIComponent(id)}`, {
        method: 'delete',
        credentials: 'include',
    });
    const responseOBJ = await responseJSON.json();
    return responseOBJ;
}

export const updateCompanyState = async (id, newState) => {
    const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/updatecompanystate?id=${encodeURIComponent(id)}&newstate=${encodeURIComponent(JSON.stringify(newState))}`, {
        method: 'put',
        credentials: 'include',
    });
    const responseOBJ = await responseJSON.json();
    return responseOBJ;
}

export const addReview = async (numberOfStars, companyId, comment) => {
    const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/reviews`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ numberOfStars, companyId, comment }),
    });
    const responseOBJ = await responseJSON.json();
    return responseOBJ;
}

export const editReview = async (numberOfStars, companyId, comment) => {
    const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/reviews`, {
        method: 'put',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ numberOfStars, companyId, comment }),
    });
    const responseOBJ = await responseJSON.json();
    return responseOBJ;
}

export const savePromotion = async (promotionData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/promotions`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Origin": window.location.origin
            },
            credentials: "include",
            body: JSON.stringify(promotionData),
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error al guardar la promoción:", error);
        return {
            success: false,
            message: "Error al guardar la promoción",
        };
    }
};

export const getPromotions = async (userProvince = null) => {
    try {
        // Añadimos el parámetro de provincia como query string si está disponible
        const url = userProvince 
            ? `${process.env.REACT_APP_API_URL}/promotions?province=${encodeURIComponent(userProvince)}` 
            : `${process.env.REACT_APP_API_URL}/promotions`;
        
        const response = await fetch(url, {
            headers: {
                "Accept": "application/json",
                "Origin": window.location.origin
            },
            credentials: "include"
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error al obtener las promociones:", error);
        return {
            success: false,
            message: "Error al obtener las promociones",
            promotions: [],
        };
    }
};

export const deleteReview = async (companyId) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/reviews?companyId=${encodeURIComponent(companyId)}`, {
            method: 'delete',
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const deleteUserById = async (userId) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/deleteuser?id=${encodeURIComponent(userId)}`, {
            method: 'delete',
            credentials: 'include',
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const replyReview = async (companyId, reviewUserEmail, replyText) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/replyreview`, {
            method: 'put',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ companyId, reviewUserEmail, replyText })
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const reportReview = async (companyId, reviewUserEmail, reason) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/reportreview`, {
            method: 'put',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ companyId, reviewUserEmail, reason })
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const moderateReview = async (companyId, reviewUserEmail) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/moderatereview?companyId=${encodeURIComponent(companyId)}&reviewUserEmail=${encodeURIComponent(reviewUserEmail)}`, {
            method: 'DELETE',
            credentials: 'include'
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const generateDescriptionAI = async (companyData, style, currentDesc) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/ai/generate-description`, {
            method: 'post',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ companyData, style, currentDesc })
        });
        
        if (!responseJSON.ok) {
            throw new Error(`API error: ${responseJSON.status}`);
        }
        
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        // Fallback Inteligente (Mock Local) en caso de que el backend aún no implemente el endpoint
        console.warn("Backend AI endpoint failed or missing. Using intelligent local mock.", error);
        
        const name = companyData.name || "Tu negocio";
        const cat = companyData.subcategory || companyData.category || "servicios automotrices";
        const city = companyData.city || "tu ciudad";
        
        let catKeywords = "";
        let catServices = "";
        const catLower = cat.toLowerCase();

        if (catLower.includes("estética") || catLower.includes("lavadero") || catLower.includes("detailing")) {
            catKeywords = "el cuidado estético y la protección de tu vehículo";
            catServices = "lavado premium, detailing, limpieza interior profunda, tratamientos acrílicos y encerado profesional";
        } else if (catLower.includes("mecánica") || catLower.includes("taller")) {
            catKeywords = "el óptimo funcionamiento y seguridad de tu vehículo";
            catServices = "diagnóstico computarizado, mantenimiento preventivo, reparación de motores y revisión técnica integral";
        } else if (catLower.includes("repuesto") || catLower.includes("accesorio")) {
            catKeywords = "equipamiento y refacciones de alta calidad";
            catServices = "un amplio catálogo de repuestos originales, accesorios personalizados, baterías y lubricantes";
        } else if (catLower.includes("gomeria") || catLower.includes("neumático") || catLower.includes("llanta")) {
            catKeywords = "el rodamiento seguro y balanceado de tu auto";
            catServices = "venta de neumáticos, alineación 3D, balanceo computarizado y reparación de llantas";
        } else {
            catKeywords = `soluciones especializadas en ${catLower}`;
            catServices = `servicios personalizados y atención de primera calidad para tu vehículo`;
        }
        
        let mockDesc = "";
        
        if (style === "Profesional") {
            mockDesc = `${name} es un centro especializado en ${catKeywords}, ubicado estratégicamente en ${city}. Nos destacamos por ofrecer ${catServices}, respaldados por un equipo técnico capacitado. Nuestro objetivo es garantizar resultados de excelencia, brindando tranquilidad y confianza a cada uno de nuestros clientes mediante procesos estandarizados y atención meticulosa.`;
        } else if (style === "Cercano") {
            mockDesc = `¡Hola! Somos ${name}, tu lugar de confianza en ${city} para todo lo relacionado con ${catLower}. Sabemos lo mucho que te importa tu vehículo, por eso lo tratamos como si fuera nuestro. Nos especializamos en ofrecerte ${catServices}. Vení a visitarnos; te esperamos con la mejor atención al cliente y la disposición de siempre para dejar tu auto impecable.`;
        } else if (style === "Técnico") {
            mockDesc = `Centro integral de ${catLower} radicado en ${city}. ${name} opera mediante protocolos estandarizados orientados a ${catKeywords}. El portafolio de operaciones incluye ${catServices}, empleando insumos de alto rendimiento y maquinaria especializada para asegurar la integridad técnica de las unidades intervenidas.`;
        } else {
            // Comercial
            mockDesc = `¡Destacá tu vehículo con ${name}! Somos la opción líder en ${city} enfocada en ${catKeywords}. Elevá tu experiencia automotriz con nuestro catálogo de ${catServices}. Trabajamos con los más altos estándares para que tu auto luzca y funcione perfecto. ¡Reservá tu turno hoy y comprobá por qué somos los número uno en ${catLower}!`;
        }
        
        // Simular delay de red
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({ success: true, description: mockDesc });
            }, 1500);
        });
    }
};

export const logInteraction = async (companyId, type, userEmail = null) => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}api/company/interaction`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ companyId, type, userEmail })
        });
    } catch (error) {
        console.error("Error logging interaction:", error);
    }
};

export const logSearch = async (query, resultsCount, source, userEmail = null) => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}api/log-search`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ query, resultsCount, source, userEmail })
        });
    } catch (error) {
        console.error("Error logging search:", error);
    }
};

export const getCompanyAnalytics = async (companyId, range) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/company/analytics?companyId=${companyId}&range=${range}`, {
            method: 'get',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"
            }
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const getAdminInsights = async () => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/admin/insights`, {
            method: 'get',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"
            }
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const getSponsors = async () => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/sponsors`, {
            method: 'GET',
            credentials: 'include'
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const saveSponsors = async (sponsorsData) => {
    try {
        const responseJSON = await fetch(`${process.env.REACT_APP_API_URL}api/sponsors`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ sponsors: sponsorsData })
        });
        const responseOBJ = await responseJSON.json();
        return responseOBJ;
    } catch (error) {
        return { success: false, message: error.message };
    }
};
